import { useContext } from "react";
import { ThemeContext } from "styled-components";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useScreen = () => {
  const { mediaQueries } = useContext(ThemeContext);
  const desktop = useMediaQuery(mediaQueries.desktop);
  const dashboardDesktop = useMediaQuery(mediaQueries.dashboardDesktop);
  const containerMaxBreakpoint = useMediaQuery(
    mediaQueries.containerMaxBreakpoint
  );
  const mobile = useMediaQuery(mediaQueries.mobile);

  return { desktop, dashboardDesktop, containerMaxBreakpoint, mobile };
};

export default useScreen;
